import { Button, GridItem, Heading, Image, SimpleGrid, Text } from '@chakra-ui/react';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';

type SectionProps = {
  title: string;
  subtitle: string;
  link: string;
  image: string;
  imageWidth: number;
};

export const Section: React.FC<SectionProps> = ({ subtitle, image, imageWidth, link, title }) => {
  return (
    <SimpleGrid
      columns={[1, 1, 1, 2]}
      w="full"
      backgroundColor={'blue.900'}
      borderRadius="20px"
      gridTemplateColumns={['auto', 'auto', 'auto', 'auto auto']}>
      <GridItem padding="40px" gap={['12px', '12px', '12px', '20px']} display="flex" flexDir={'column'}>
        <Heading
          textAlign={['center', 'center', 'center', 'left']}
          fontSize={['28px', '28px', '28px', '40px']}
          lineHeight={'48px'}
          fontFamily={FontFamily.HELVETICA_NOW_BOLD}
          fontWeight={'normal'}
          color="white">
          {title}
        </Heading>
        <Text
          textAlign={['center', 'center', 'center', 'left']}
          fontSize={['16px', '16px', '16px', '20px']}
          lineHeight={['20px', '20px', '20px', '24px']}
          color="gray.300"
          mb="10px">
          {subtitle}
        </Text>
        <Button
          alignSelf={['center', 'center', 'center', 'flex-start']}
          variant={'solid'}
          backgroundColor="white"
          onClick={() => window.open(link, '_blank') as any}
          color="black"
          fontSize={['12px', '12px', '12px', '16px']}
          fontFamily={FontFamily.HELVETICA_NOW_BOLD}
          fontWeight={'normal'}
          w="max-content"
          _hover={{
            backgroundColor: 'white',
          }}>
          Learn More
        </Button>
      </GridItem>
      <GridItem
        display="flex"
        justifyContent={['center', 'center', 'center', 'flex-end']}
        alignItems={['center', 'center', 'center', 'flex-end']}
        minW={['auto', 'auto', 'auto', 'max-content']}
        padding={['0 40px 0', '0 40px 0', '0 40px 0', '40px 40px 0 0']}>
        <Image src={image} w={[`100%`, '100%', '100%', imageWidth]} />
      </GridItem>
    </SimpleGrid>
  );
};
